export default __webpack_public_path__ + "static/media/chat-dark-18x14.5d533f13.svg";